import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FieldValue } from '@vendasta/crm';
import { FieldValueInterface } from '../../../tokens-and-interfaces';

@Injectable({ providedIn: 'root' })
export class UpdaterService {
  updatedField: BehaviorSubject<FieldValueInterface>;
  private clearedField$$ = new Subject<FieldValueInterface>();
  clearedField$ = this.clearedField$$.asObservable();

  constructor() {
    this.updatedField = new BehaviorSubject<FieldValueInterface>(new FieldValue());
  }

  private clearField(fieldId: string): void {
    this.clearedField$$.next(new FieldValue({ fieldId: fieldId }));
  }

  updateStringField(fieldId: string, value: string, clearIfEmpty?: boolean): void {
    if (!value && clearIfEmpty) {
      this.clearField(fieldId);
      return;
    }

    this.updatedField.next(new FieldValue({ fieldId: fieldId, stringValue: value }));
  }

  updateStringListField(fieldId: string, values: string[], clearIfEmpty?: boolean): void {
    if (!values || values.length === 0) {
      if (clearIfEmpty) {
        this.clearField(fieldId);
      }
      return;
    }

    this.updatedField.next(new FieldValue({ fieldId: fieldId, stringValues: { values: values } }));
  }

  updateGeopointField(fieldId: string, lat: number, lon: number, clearIfEmpty?: boolean): void {
    if (lat === 0 && lon === 0 && clearIfEmpty) {
      this.clearField(fieldId);
      return;
    }

    this.updatedField.next(new FieldValue({ fieldId: fieldId, geopointValue: { lat: lat, lon: lon } }));
  }

  updateFieldValue(value: FieldValueInterface): void {
    this.updatedField.next(new FieldValue(value));
  }
}
